import React from 'react';
import BackgroundImage from '../components/BackgroundImage/BackgroundImage';
import illustration from '../assets/illustration-sample.jpg';
import LoginForm from '../components/LoginForm/LoginForm';

const SplitIllustration = () => (
  <div className="container-fluid">
    <div className="row min-vh-100">
      <LoginForm
        backgroundColor="white"
        heading="Welcome back!"
        subheading="Enter your email and password and we'll get you signed in."
        isFlat
      />
      <BackgroundImage
        imageCenter={illustration}
      />
    </div>
  </div>
);

export default SplitIllustration;
